NewEmployeeController.$inject = ['$scope', 'CorporateService', 'AppService', '$uibModal', '$transitions', '$timeout']

export default function NewEmployeeController($scope, CorporateService, AppService, $uibModal, $transitions, $timeout) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var shell = $scope.$parent.shell
  vm.worker = CorporateService.initEmployee()

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPublished = function() {
    vm.worker.isPublished = !vm.worker.isPublished
  }
  $transitions.onBefore({}, () => {
    if (!vm.cancelled && !$scope.pristine.isPristine()) {
      CorporateService.postEmployee(vm.worker).then(() => {
        if (sessionStorage.getItem('taskId') && sessionStorage.getItem('contactId')) {
          AppService.postTaskResponse(sessionStorage.getItem('taskId'), sessionStorage.getItem('contactId')).then(() => {
            shell.invitedTeamMembers = true
            sessionStorage.removeItem('taskId')
            sessionStorage.removeItem('contactId')
            $timeout(function() {
              shell.hideAlert('invitedTeamMembers')
            }, 5000)
          })
        }
      })
    } else {
      sessionStorage.removeItem('taskId')
      sessionStorage.removeItem('contactId')
    }
  }, {invokeLimit: 1})
}